.avatar {
  display: inline-grid; place-items: center; flex: none; overflow: hidden;
  border-radius: var(--radius-full);
  background: color-mix(in oklab, var(--hue) 16%, var(--color-surface));
  /* Initials darker than the hue itself: the lighter label hues miss 4.5:1 on their own tint. */
  color: color-mix(in oklab, var(--hue) 72%, #000); font-weight: var(--weight-semibold); letter-spacing: 0.02em; user-select: none;
}
:root[data-theme="dark"] .avatar { background: color-mix(in oklab, var(--hue) 30%, var(--color-surface)); color: color-mix(in oklab, var(--hue) 35%, white); }
.avatar img { width: 100%; height: 100%; object-fit: cover; }
.wrap { position: relative; display: inline-flex; flex: none; }
.dot { position: absolute; right: -1px; bottom: -1px; border-radius: var(--radius-full); box-shadow: 0 0 0 2px var(--color-surface); }
.online { background: var(--color-success); }
.away { background: var(--color-surface); box-shadow: inset 0 0 0 2px var(--color-warning), 0 0 0 2px var(--color-surface); }
.offline { background: var(--color-surface); box-shadow: inset 0 0 0 2px var(--color-text-muted), 0 0 0 2px var(--color-surface); }
